module.exports = __webpack_public_path__ + "static/media/icon-download-white.c722b406.svg";